import { render, staticRenderFns } from "./ProjectLimitReached.vue?vue&type=template&id=353c6926&scoped=true&"
import script from "./ProjectLimitReached.vue?vue&type=script&lang=js&"
export * from "./ProjectLimitReached.vue?vue&type=script&lang=js&"
import style0 from "./ProjectLimitReached.vue?vue&type=style&index=0&id=353c6926&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353c6926",
  null
  
)

export default component.exports